<!-- Estilos: sistema .lx-* (_liga-ui.scss) + .lxd-* (_liga-d.scss); el .scss del componente solo lleva :host. -->
<p class="lx-sr" role="status" aria-live="polite">{{anuncio}}</p>

<!-- Encabezado compartido de la firma -->
<ng-template #hero let-titulo="titulo" let-subtitulo="subtitulo" let-icono="icono" let-tono="tono" let-conEtapas="conEtapas">
  <header class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-hero__icono" [ngClass]="tono ? 'lx-hero__icono--' + tono : ''" aria-hidden="true"><fa-icon [icon]="icono"></fa-icon></span>
      <div class="lx-hero__textos">
        <span class="lx-hero__eyebrow">Firma de contrato</span>
        <h2 class="lx-hero__titulo">{{titulo}}</h2>
        <p class="lx-hero__subtitulo">{{subtitulo}}</p>
        <span class="lx-chip" *ngIf="data.comment && !startedProcess && !firmado" [ngClass]="estados.corrige.chip">
          <fa-icon *ngIf="estados.corrige.icono as icono" [icon]="icono" aria-hidden="true"></fa-icon>{{estados.corrige.texto}}
        </span>
      </div>
    </div>
    <div class="lx-hero__pie" *ngIf="conEtapas">
      <ol class="lx-etapas" [attr.aria-label]="'Parte ' + (etapa + 1) + ' de 3'">
        <li [ngClass]="claseEtapa(0)" [attr.aria-current]="etapa === 0 ? 'step' : null">
          <span class="lx-etapas__barra" aria-hidden="true"></span>
          <span class="lx-etapas__texto">
            <span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="etapa > 0 || firmado; else uno" [icon]="iconos.listo"></fa-icon><ng-template #uno>1</ng-template></span>Revisa
          </span>
        </li>
        <li [ngClass]="claseEtapa(1)" [attr.aria-current]="etapa === 1 ? 'step' : null">
          <span class="lx-etapas__barra" aria-hidden="true"></span>
          <span class="lx-etapas__texto">
            <span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="etapa > 1 || firmado; else dos" [icon]="iconos.listo"></fa-icon><ng-template #dos>2</ng-template></span>Firma
          </span>
        </li>
        <li [ngClass]="claseEtapa(2)" [attr.aria-current]="etapa === 2 ? 'step' : null">
          <span class="lx-etapas__barra" aria-hidden="true"></span>
          <span class="lx-etapas__texto"><span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="firmado; else tres" [icon]="iconos.listo"></fa-icon><ng-template #tres>3</ng-template></span>Confirma</span>
        </li>
      </ol>
    </div>
  </header>
</ng-template>

<ng-template #seguro>
  <p class="lx-seguro">
    <span class="lx-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.seguro"></fa-icon></span>
    <span>Tu firma viaja cifrada y solo se usa para este contrato.</span>
  </p>
</ng-template>

<!-- Preparando el contrato: esqueleto en lugar de la pantalla en blanco -->
<section class="lx-pagina" lang="es" *ngIf="cargando; else yaCargado" aria-busy="true" aria-label="Preparando tu contrato">
  <div class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-esqueleto lx-esqueleto--icono"></span>
      <div class="lx-hero__textos lx-pila lx-pila--chica">
        <span class="lx-esqueleto lx-esqueleto--corto"></span>
        <span class="lx-esqueleto lx-esqueleto--titulo"></span>
        <span class="lx-esqueleto"></span>
      </div>
    </div>
    <div class="lx-hero__pie"><span class="lx-esqueleto"></span></div>
  </div>
  <div class="lx-tarjeta lxd-contrato">
    <span class="lx-esqueleto lx-esqueleto--bloque" style="flex: 0 0 76px; height: 92px"></span>
    <div class="lxd-contrato__textos lx-pila lx-pila--chica">
      <span class="lx-esqueleto lx-esqueleto--titulo"></span>
      <span class="lx-esqueleto"></span>
      <span class="lx-esqueleto lx-esqueleto--corto"></span>
    </div>
  </div>
  <p class="lx-seguro lx-seguro--ayuda">
    <span class="lx-seguro__icono" aria-hidden="true"><span class="lx-spinner"></span></span>
    <span>Estamos preparando tu contrato…</span>
  </p>
</section>

<ng-template #yaCargado>
  <!-- No se pudo preparar el contrato -->
  <section class="lx-pagina" lang="es" *ngIf="errorCarga; else conContrato">
    <ng-container *ngTemplateOutlet="hero; context: {titulo: 'No pudimos preparar tu contrato', subtitulo: 'Vuelve a intentarlo en un momento.', icono: iconos.contrato, tono: 'navy', conEtapas: false}"></ng-container>
    <div class="lx-alerta lx-alerta--error" role="alert">
      <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
      <div class="lx-alerta__cuerpo">
        <p class="lx-alerta__titulo">Algo salió mal</p>
        <p class="lx-alerta__texto" *ngIf="mensaje">{{mensaje}}</p>
        <button type="button" class="lx-btn lx-btn--secundario lx-btn--chico lx-btn--auto lx-alerta__accion" (click)="getUrl()">
          <fa-icon [icon]="iconos.reintentar" aria-hidden="true"></fa-icon><span>Reintentar</span>
        </button>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="seguro"></ng-container>
  </section>
</ng-template>

<ng-template #conContrato>
  <!-- Firmado: celebración mientras te llevamos al siguiente paso -->
  <section class="lx-pagina" lang="es" *ngIf="firmado; else porFirmar">
    <ng-container *ngTemplateOutlet="hero; context: {titulo: 'Contrato firmado', subtitulo: 'Ya tenemos tu firma.', icono: iconos.contrato, tono: 'verde', conEtapas: true}"></ng-container>
    <div class="lx-celebracion" role="status">
      <div class="lx-celebracion__check">
        <svg class="lx-check" viewBox="0 0 52 52" aria-hidden="true">
          <circle class="lx-check__circulo" cx="26" cy="26" r="25"></circle>
          <path class="lx-check__trazo" d="M15 27.5l7 7 15-16"></path>
        </svg>
      </div>
      <h2 class="lx-celebracion__titulo">{{yaFirmado ? 'Tu contrato ya está firmado' : '¡Listo! Firmaste tu contrato'}}</h2>
      <p class="lx-celebracion__msg">{{mensaje || 'Ya tenemos tu firma.'}}</p>
      <button type="button" class="lx-btn lx-btn--primario" (click)="terminar()"><span>Continuar</span></button>
      <p class="lx-celebracion__nota">Te regresamos a tus pasos en unos segundos.</p>
    </div>
    <ng-container *ngTemplateOutlet="seguro"></ng-container>
  </section>
</ng-template>

<ng-template #porFirmar>
  <ng-container *ngIf="!startedProcess; else elseProcess">
    <!-- 1. Revisa: qué vas a firmar y cómo -->
    <section class="lx-pagina lx-pagina--con-cta" lang="es">
      <ng-container *ngTemplateOutlet="hero; context: {titulo: 'Firma tu contrato', subtitulo: 'Lo lees y lo firmas desde tu celular, sin imprimir nada.', icono: iconos.contrato, conEtapas: true}"></ng-container>

      <div class="lx-alerta lx-alerta--error" *ngIf="data.comment && data.comment !== ''">
        <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
        <div class="lx-alerta__cuerpo">
          <p class="lx-alerta__titulo">Necesitamos que vuelvas a firmar</p>
          <p class="lx-alerta__texto">Motivo: <strong>{{data.comment}}</strong></p>
        </div>
      </div>

      <section class="lx-tarjeta lxd-contrato" aria-labelledby="firma-contrato-titulo">
        <span class="lxd-contrato__hoja" aria-hidden="true">
          <svg viewBox="0 0 76 92">
            <defs>
              <linearGradient id="lxd-hoja-degradado" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stop-color="#8587F8"></stop>
                <stop offset="1" stop-color="#5D5FEF"></stop>
              </linearGradient>
            </defs>
            <rect x="2" y="2" width="60" height="80" rx="10" fill="#EEF0FF"></rect>
            <rect x="10" y="9" width="60" height="80" rx="10" fill="#fff" stroke="#C7C9F4" stroke-width="1.5"></rect>
            <rect x="19" y="19" width="28" height="6" rx="3" fill="url(#lxd-hoja-degradado)"></rect>
            <rect x="19" y="32" width="42" height="4" rx="2" fill="#E4E6F0"></rect>
            <rect x="19" y="41" width="36" height="4" rx="2" fill="#E4E6F0"></rect>
            <rect x="19" y="50" width="42" height="4" rx="2" fill="#E4E6F0"></rect>
            <path class="lxd-contrato__trazo" pathLength="60" d="M20 73c3-6 6-7 7-2s3 5 6-1 5-5 6 0 4 3 8-2" fill="none" stroke="#5D5FEF" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <rect x="19" y="79" width="42" height="1.5" rx=".75" fill="#C7C9F4"></rect>
            <g transform="translate(46 54)">
              <g class="lxd-contrato__pluma">
                <path d="M2 20 5 12 18-1 23 4 10 17Z" fill="url(#lxd-hoja-degradado)"></path>
                <path d="M2 20 5 12 10 17Z" fill="#23223F"></path>
              </g>
            </g>
          </svg>
        </span>
        <div class="lxd-contrato__textos">
          <h3 class="lx-tarjeta__titulo" id="firma-contrato-titulo">Tu contrato</h3>
          <p class="lx-tarjeta__subtitulo">Se abre en una ventana segura para que lo leas y lo firmes.</p>
          <div class="lxd-contrato__chips">
            <span class="lx-chip" [ngClass]="startButtonIsAvailable ? 'lx-chip--listo' : 'lx-chip--pendiente'">
              <fa-icon *ngIf="startButtonIsAvailable" [icon]="iconos.listo" aria-hidden="true"></fa-icon>{{startButtonIsAvailable ? 'Listo para firmar' : 'Aún no está listo'}}
            </span>
          </div>
        </div>
      </section>

      <section class="lx-tarjeta" aria-labelledby="firma-antes-titulo">
        <h3 class="lx-tarjeta__titulo" id="firma-antes-titulo">Antes de empezar</h3>
        <ol class="lx-lista lx-lista--numerada" style="margin-top: 12px">
          <li>Busca una buena conexión a internet.</li>
          <li>Lee tu contrato y firma igual que en tu identificación oficial.</li>
          <li>Al terminar, regresa aquí y toca <strong>«Ya firmé»</strong>.</li>
        </ol>
      </section>

      <ng-container *ngTemplateOutlet="seguro"></ng-container>
    </section>

    <div class="lx-cta-fijo">
      <button type="button" class="lx-btn lx-btn--primario" [class.is-cargando]="abriendo" [attr.aria-busy]="abriendo"
              [disabled]="!startButtonIsAvailable && !abriendo" (click)="start()">
        <span class="lx-spinner" *ngIf="abriendo; else iconoFirmar" aria-hidden="true"></span>
        <ng-template #iconoFirmar><fa-icon [icon]="iconos.firmar" aria-hidden="true"></fa-icon></ng-template>
        <span>{{abriendo ? 'Abriendo tu contrato…' : 'Firmar mi contrato'}}</span>
      </button>
      <p class="lx-cta-fijo__nota"><fa-icon [icon]="iconos.abrir" aria-hidden="true"></fa-icon>Se abre en una ventana nueva.</p>
    </div>
  </ng-container>

  <ng-template #elseProcess>
    <!-- 2. Firmando: esperando que termine en la ventana de firma -->
    <section class="lx-pagina lx-pagina--con-cta" lang="es">
      <ng-container *ngTemplateOutlet="hero; context: {titulo: textosEspera.titulo, subtitulo: textosEspera.subtitulo, icono: iconos.firmar, conEtapas: true}"></ng-container>

      <div class="lx-alerta lx-alerta--exito" role="status" *ngIf="firmaDetectada && !resultado && !confirmando">
        <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.listo"></fa-icon></span>
        <div class="lx-alerta__cuerpo">
          <p class="lx-alerta__titulo">¡Detectamos tu firma!</p>
          <p class="lx-alerta__texto">Toca «Ya firmé» para continuar.</p>
        </div>
      </div>

      <div class="lx-alerta lx-alerta--aviso" role="alert" *ngIf="ventanaBloqueada">
        <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.aviso"></fa-icon></span>
        <div class="lx-alerta__cuerpo">
          <p class="lx-alerta__titulo">Tu navegador no abrió la ventana</p>
          <p class="lx-alerta__texto">Ábrela desde aquí para firmar.</p>
          <a class="lx-btn lx-btn--secundario lx-btn--chico lx-btn--auto lx-alerta__accion" [href]="currentUrl" target="_blank" rel="noopener">
            <fa-icon [icon]="iconos.abrir" aria-hidden="true"></fa-icon><span>Abrir mi contrato</span>
          </a>
        </div>
      </div>

      <section class="lx-tarjeta lxd-espera" *ngIf="confirmando" aria-busy="true">
        <span class="lx-spinner lx-spinner--grande" aria-hidden="true"></span>
        <div>
          <p class="lx-tarjeta__titulo">Confirmando tu firma…</p>
          <p class="lx-tarjeta__subtitulo">Toma unos segundos. No cierres esta pantalla.</p>
        </div>
      </section>

      <div class="lx-alerta lx-alerta--error" role="alert" *ngIf="resultado === 'error'">
        <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
        <div class="lx-alerta__cuerpo">
          <p class="lx-alerta__titulo">Aún no podemos confirmar tu firma</p>
          <p class="lx-alerta__texto">{{mensaje || 'Inténtalo de nuevo en un momento.'}}</p>
        </div>
      </div>

      <div class="lx-alerta lx-alerta--aviso" role="status" *ngIf="resultado === 'pendiente'">
        <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.info"></fa-icon></span>
        <div class="lx-alerta__cuerpo">
          <p class="lx-alerta__titulo">Tu firma sigue en proceso</p>
          <p class="lx-alerta__texto" *ngIf="mensaje">{{mensaje}}</p>
        </div>
      </div>

      <section class="lx-tarjeta" *ngIf="!confirmando && !ventanaBloqueada && resultado !== 'pendiente'" aria-labelledby="firma-reabrir-titulo">
        <h3 class="lx-tarjeta__titulo" id="firma-reabrir-titulo">¿Se cerró la ventana de firma?</h3>
        <p class="lx-tarjeta__subtitulo">Vuelve a abrirla y termina de firmar.</p>
        <div class="lx-tarjeta__pie">
          <button type="button" class="lx-btn lx-btn--secundario" [class.is-cargando]="abriendo" [disabled]="abriendo" (click)="start()">
            <span class="lx-spinner" *ngIf="abriendo; else iconoAbrir" aria-hidden="true"></span>
            <ng-template #iconoAbrir><fa-icon [icon]="iconos.abrir" aria-hidden="true"></fa-icon></ng-template>
            <span>{{abriendo ? 'Abriendo tu contrato…' : 'Volver a abrir mi contrato'}}</span>
          </button>
        </div>
      </section>

      <ng-container *ngTemplateOutlet="seguro"></ng-container>
    </section>

    <div class="lx-cta-fijo">
      <button type="button" class="lx-btn lx-btn--primario" [class.is-cargando]="confirmando" [attr.aria-busy]="confirmando"
              [disabled]="resultado === 'pendiente'" (click)="validateUserSign()">
        <span class="lx-spinner" *ngIf="confirmando || resultado === 'pendiente'; else iconoListo" aria-hidden="true"></span>
        <ng-template #iconoListo><fa-icon [icon]="iconos.listo" aria-hidden="true"></fa-icon></ng-template>
        <span>{{confirmando ? 'Confirmando tu firma…' : (resultado === 'pendiente' ? 'Volviendo a tus pasos…' : 'Ya firmé, continuar')}}</span>
      </button>
      <p class="lx-cta-fijo__nota">{{textosEspera.nota}}</p>
    </div>
  </ng-template>
</ng-template>
